import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/hanh-chinh/muon-tai-san'

// Lọc danh sách phiếu mượn
export function locPhieuMuonTaiSan(querySt?: string | Record<string, unknown>) {
  try {
    const query = typeof querySt === 'string' ? queryString.parse(querySt) : querySt || {}
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách phiếu mượn của user
export function layDanhSachPhieuMuonCuaNguoiDung(borrowerId: number) {
  try {
    return axiosApi.get(`${BASE}/nguoi-dung/${borrowerId}/danh-sach`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết phiếu mượn
export function layChiTietPhieuMuonTaiSan(id: number) {
  try {
    return axiosApi.get(`${BASE}/${id}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách phiếu mượn của tài sản
export function layDanhSachPhieuMuonTheoTaiSan(assetId: number) {
  try {
    return axiosApi.get(`${BASE}/${assetId}/phieu-muon`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo phiếu mượn tài sản
export function taoPhieuMuonTaiSan(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Duyệt phiếu mượn
export function pheDuyetPhieuMuonTaiSan(id: number, params?: any) {
  try {
    return axiosApi.post(`${BASE}/${id}/phe-duyet`, params || {})
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Từ chối phiếu mượn
export function tuChoiPhieuMuonTaiSan(id: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/${id}/tu-choi`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Yêu cầu bổ sung thông tin
export function yeuCauBoSungThongTinPhieuMuon(id: number, message: string) {
  try {
    return axiosApi.post(`${BASE}/${id}/yeu-cau-bo-sung?message=` + encodeURIComponent(message))
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xác nhận nhận tài sản
export function xacNhanNhanTaiSan(id: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/${id}/xac-nhan-nhan`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Trả tài sản
export function traTaiSan(id: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${id}/tra`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Báo cáo hư hỏng
export function baoCaoHuHongTaiSan(id: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/${id}/bao-cao-hu-hong`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Báo cáo mất mát
export function baoCaoMatMatTaiSan(id: number, params: any) {
  try {
    return axiosApi.post(`${BASE}/${id}/bao-cao-mat-mat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách phiếu mượn quá hạn
export function layDanhSachPhieuMuonQuaHan() {
  try {
    return axiosApi.get(`${BASE}/qua-han`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Thống kê mượn/trả tài sản
export function layThongKeMuonTraTaiSan() {
  try {
    return axiosApi.get(`${BASE}/thong-ke`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
